import { Link } from "react-router-dom";

export default function ArticleCTA() {
  return (
    <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-primary-500 blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-accent-500 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
              Learn More
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
              Read Our Complete Hipobuy Spreadsheet Guide
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Dive deeper into the world of spreadsheet-based shopping research. Our comprehensive guide covers everything from getting started to advanced product research techniques, safety tips, and comparison strategies. Whether you are a beginner or an experienced shopper, this guide has something valuable for you.
            </p>
            <Link
              to="/hipobuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap hover:-translate-y-0.5 shadow-lg shadow-primary-500/20"
            >
              Read the Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20library%20corner%20with%20a%20large%20open%20laptop%20on%20wooden%20desk%20displaying%20clean%20spreadsheet%20interface%20with%20product%20images%2C%20stack%20of%20fashion%20and%20product%20catalogs%20beside%20the%20laptop%2C%20soft%20golden%20hour%20light%20streaming%20through%20gauze%20curtains%2C%20potted%20olive%20plant%20adding%20organic%20texture%2C%20ceramic%20mug%20with%20warm%20beverage%2C%20reading%20chair%20with%20knitted%20throw%20blanket%20in%20background%2C%20cozy%20intellectual%20atmosphere%20with%20amber%20and%20cream%20color%20palette%2C%20lifestyle%20learning%20and%20research%20photography%20with%20sophisticated%20aesthetic&width=800&height=600&seq=guide-v2-2026-jul&orientation=landscape"
              alt="Complete Hipobuy Spreadsheet shopping guide and tutorial"
              title="Hipobuy Spreadsheet Complete Guide"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}